import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  RCS_BROADCAST_SCHEDULE_DEFAULT, RCS_READ_CONDITION_DISABLED, RcsBroadcastScheduleSettings, RcsReadConditionSettings, RcsSettings,
} from 'src/app/models/Rcs';
import { environment } from 'src/environments/environment';

/**
 * Flags do RCS que o painel lê (`GET /api/rcs/settings`, atrás de `rcs.enabled`).
 *
 * A condição por leitura da etapa da automação (F7.5), atrás da flag global
 * `RCS_SEQUENCE_READ_CONDITION`: sem resposta (erro, 403, backend antigo), tudo desligado,
 * o campo não aparece e a etapa grava sem a condição. E o teto do agendamento do envio em
 * massa (validade da reserva na carteira): sem resposta, o teto padrão do backend.
 */
@Injectable({ providedIn: 'root' })
export class RcsSettingsService {

  private readonly url = `${environment.apiUrl}/rcs/settings`;

  constructor(private http: HttpClient) {}

  readCondition(): Observable<RcsReadConditionSettings> {
    return this.http.get<RcsSettings>(this.url).pipe(
      map(response => {
        const settings = { ...RCS_READ_CONDITION_DISABLED, ...(response?.read_condition || {}) };
        return { ...settings, enabled: settings.enabled === true };
      }),
      catchError(() => of(RCS_READ_CONDITION_DISABLED)),
    );
  }

  broadcastSchedule(): Observable<RcsBroadcastScheduleSettings> {
    return this.http.get<RcsSettings>(this.url).pipe(
      map(response => {
        const schedule = response?.broadcast_schedule;
        const valid = Number(schedule?.max_minutes) > 0 && Number(schedule?.max_days) > 0;
        return valid
          ? { max_days: Number(schedule.max_days), max_minutes: Number(schedule.max_minutes) }
          : RCS_BROADCAST_SCHEDULE_DEFAULT;
      }),
      catchError(() => of(RCS_BROADCAST_SCHEDULE_DEFAULT)),
    );
  }
}
